var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D3736",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M4.95 1.925h12.1c1.008 0 1.833.825 1.833 1.833v2.017c0 .733-.458 1.65-.916 2.108l-3.942 3.484c-.55.458-.917 1.375-.917 2.108v3.942c0 .55-.366 1.283-.825 1.558L11 19.8c-1.192.733-2.842-.092-2.842-1.558v-4.859c0-.641-.366-1.466-.733-1.925L3.942 7.792c-.459-.459-.825-1.284-.825-1.834V3.85c0-1.1.825-1.925 1.833-1.925M10.02 1.925 5.5 9.167"
  })));
};
export default SvgFilter;